import { render, staticRenderFns } from "./mailboxManagementDialog.vue?vue&type=template&id=c08d492c&"
import script from "./mailboxManagementDialog.vue?vue&type=script&lang=js&"
export * from "./mailboxManagementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c08d492c')) {
      api.createRecord('c08d492c', component.options)
    } else {
      api.reload('c08d492c', component.options)
    }
    module.hot.accept("./mailboxManagementDialog.vue?vue&type=template&id=c08d492c&", function () {
      api.rerender('c08d492c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/mailboxManagementDialog.vue"
export default component.exports